module.exports = __webpack_public_path__ + "images/pflegegrad3.svg?843369f4420a749b8c5d1d8c9b49c820";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pflegegrad3.svg
// module id = pgMd
// module chunks = 0